import { useEffect, useRef, type ReactNode } from "react";

/**
 * Previously a scroll-triggered animation wrapper. Content is now rendered
 * immediately (no fade/rise on scroll) — kept as a passthrough so existing
 * layouts and spacing stay exactly as they are.
 */
export function Reveal({
  children,
  className = "",
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) {
        node.classList.add("journal-revealed");
        observer.unobserve(node);
      }
    }, { threshold: 0.08 });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`journal-reveal ${className}`}>{children}</div>;
}
